import { C } from '../../theme';
import { BoutonDeuxGestes } from './BoutonDeuxGestes';

/**
 * Le couple « Modifier » / « Retirer » d'une chose du planning (lot E1 pour les
 * evenements, lot E2 pour le reste). Discret par construction : ce sont des commandes de
 * reparation, pas l'action principale de l'ecran.
 *
 * Le retrait passe toujours par deux gestes — un pouce qui glisse ne detruit rien.
 */
export function ActionsLigne({
  libelleModifier = 'Modifier',
  libelleRetirer = 'Retirer',
  ariaModifier,
  ariaRetirer,
  ariaRetirerArme,
  occupe,
  onModifier,
  onRetirer,
}: {
  libelleModifier?: string;
  libelleRetirer?: string;
  ariaModifier: string;
  ariaRetirer: string;
  ariaRetirerArme: string;
  occupe: boolean;
  onModifier: () => void;
  onRetirer: () => void;
}) {
  const style = {
    background: 'none',
    border: 'none',
    padding: 0,
    fontSize: 11.5,
    fontWeight: 800,
    fontFamily: 'inherit',
    cursor: occupe ? ('default' as const) : ('pointer' as const),
  };

  return (
    <>
      <button
        type="button"
        className="pressable"
        disabled={occupe}
        aria-label={ariaModifier}
        onClick={onModifier}
        style={{ ...style, color: C.violetTexte }}
      >
        {libelleModifier}
      </button>
      <BoutonDeuxGestes
        libelle={libelleRetirer}
        libelleArme="Confirmer ?"
        aria={ariaRetirer}
        ariaArme={ariaRetirerArme}
        occupe={occupe}
        onConfirmer={onRetirer}
        style={{ ...style, color: C.tertiaire }}
        styleArme={{ color: C.corailTexte }}
      />
    </>
  );
}
